import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ['field'];

  connect() {
    this.initToast();
    this.element.addEventListener('hidden.bs.toast', () => this.element.remove());
  }

  initToast() {
    new bootstrap.Toast(this.fieldTarget, {
      animation: true,
      autohide: true,
      delay: 5000,
    }).show();
  }
}
